
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "@/components/Header";
import EnterpriseHero from "@/components/EnterpriseHero";
import EnterpriseFeatures from "@/components/EnterpriseFeatures";
import UseCases from "@/components/UseCases";
import HowItWorks from "@/components/HowItWorks";
import Pricing from "@/components/Pricing";
import Footer from "@/components/Footer";

const Index = () => {
  const location = useLocation();

  useEffect(() => {
    // Handle scrolling to specific sections when navigating from other pages
    if (location.state?.scrollTo) {
      const element = document.getElementById(location.state.scrollTo);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, [location]);

  return (
    <div className="min-h-screen w-full overflow-x-hidden">
      <div className="w-full">
        <Header />
        <main className="w-full">
          <EnterpriseHero />
          <EnterpriseFeatures />
      <UseCases />
      <HowItWorks />
      <Pricing />
    </main>
    <Footer />
      </div>
    </div>
  );
};

export default Index;
